export enum IntegrationStep {
  EmailValidation,
  PasswordValidation,
  PasswordCreation,
  EmailAlreadyUsed,
  CreationSuccess,
  IntegrationSuccess,
  DefaultError,
}
